module.exports = __webpack_public_path__ + "img/mp-zoom.959f5fc9.jpg";